// extracted by mini-css-extract-plugin
export default {"container":"euIYPxPy","content":"z5rzPnrw","dropzone":"O9XPH0th","active":"cXIsXHck","file":"ea3LY0uI","paragraph1":"cPuFXh15","paragraph2":"NCt4GcPL"};